import { formatDistanceToNowStrict } from '@/utils/dates';
import { SyncStatus } from '@seapoint/server/enums';
import { exhaustiveCheck } from './exhaustive-check';

type GetSyncStatusTextArgs = {
  status?: SyncStatus | null;
  lastSyncAttemptAt?: Date | null;
  nextSyncAt: Date;
};

export const getSyncStatusText = ({ status, lastSyncAttemptAt, nextSyncAt }: GetSyncStatusTextArgs) => {
  if (!status) {
    return undefined;
  }

  switch (status) {
    case SyncStatus.PENDING:
      return undefined;
    case SyncStatus.IN_PROGRESS:
      return 'Syncing...';
    case SyncStatus.COMPLETE:
      if (!lastSyncAttemptAt) {
        return undefined;
      }

      return `Last sync ${formatDistanceToNowStrict(lastSyncAttemptAt)} ago`;
    case SyncStatus.FAILED:
      if (!nextSyncAt) {
        return '';
      }
      return `Sync failed, next sync ${formatDistanceToNowStrict(nextSyncAt)} from now`;
    default:
      return exhaustiveCheck(status);
  }
};
